import type { AllButton } from '@pkg/sanity-utils/types/button';
import type { LinkType } from '@pkg/link';
import type { NewHeaderAction } from '../types/mainNav';
import { resolveNewHeaderAction } from '../types/mainNav';

const isLinkAction = (a: NewHeaderAction) => a.internalLink ?? a.externalLink ?? a.ssuLink;
const isButtonAction = (a: NewHeaderAction) => a.appstoreLink ?? a.button;

/** Resolve header actions to links and buttons for rendering. */
export function resolveHeaderActions(actions: NewHeaderAction[]): { links: LinkType[]; buttons: AllButton[] } {
  const links = actions
    .filter(isLinkAction)
    .map(a => resolveNewHeaderAction(a))
    .filter((item): item is NonNullable<typeof item> => item != null) as LinkType[];
  const buttons = actions
    .filter(isButtonAction)
    .map(a => resolveNewHeaderAction(a))
    .filter((item): item is NonNullable<typeof item> => item != null) as AllButton[];
  return { links, buttons };
}
